var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicalSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6629,
    cy: 72.0677,
    r: 16.6629,
    fill: "#FFD100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8951 64.2476C22.1976 64.3565 22.4993 64.4729 22.7953 64.6028C22.9176 64.6565 23.109 64.8068 23.2341 64.8059C23.3601 64.8877 23.3604 64.8507 23.2309 64.6984C23.1732 64.5033 23.1088 64.4989 23.0402 64.6917C22.8188 64.8333 22.6182 65.0849 22.4148 65.2583C22.1448 65.4927 21.8725 65.7262 21.6025 65.9606C21.0259 66.4584 21.7217 67.4244 22.3025 66.9231C22.7175 66.5639 23.1404 66.2108 23.5496 65.8465C23.8921 65.5377 24.2402 65.1917 24.3263 64.7174C24.5077 63.7357 23.0592 63.4026 22.3757 63.1584C21.66 62.9028 21.175 63.99 21.8983 64.2464",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6548 62.7863C28.9126 62.9966 27.626 63.4616 27.4117 64.3068C27.3018 64.7388 27.5428 65.0966 27.9111 65.3033C28.3969 65.5748 28.835 65.828 29.2468 66.2077C29.8092 66.7278 30.558 65.8014 29.9968 65.2845C29.7515 65.0575 29.4942 64.8517 29.2131 64.67C29.077 64.5811 28.9345 64.4947 28.7903 64.4181C28.7176 64.3783 28.6439 64.3406 28.5692 64.3052C28.395 64.1943 28.3815 64.3157 28.5201 64.671C28.5779 64.6725 28.7789 64.4742 28.8284 64.4402C28.958 64.3564 29.0891 64.2813 29.225 64.2135C29.4989 64.079 29.7875 63.9775 30.0815 63.8942C30.8183 63.6842 30.3799 62.5791 29.6494 62.7866",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2274 69.3017C25.7645 70.0558 27.8595 70.179 28.7196 68.394C29.0516 67.7039 27.9637 67.2266 27.6294 67.9157C27.0717 69.0719 25.596 68.6499 24.7026 68.2128C24.0154 67.8741 23.5393 68.9653 24.2252 69.3008",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6064 18.8831L78.9997 6V20.645L43.6064 33.5281V18.8831Z",
    fill: "#FFD100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9658 72.8539L45.9658 20.1572",
    stroke: "#FFD100",
    strokeWidth: 4.7191
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6406 55.5505L76.6406 20.1572",
    stroke: "#FFD100",
    strokeWidth: 4.7191
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.3817,
    cy: 55.1575,
    r: 10.618,
    fill: "#FFD100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicalSkills);
export default __webpack_public_path__ + "static/media/musical_skills.2d8059ba02b066067c9ec9db1e01e62d.svg";
export { ForwardRef as ReactComponent };